import * as dataLayerConstants from '../../../analytics/src/datalayer/constants';

window.tp = window.tp || [];
const debug = newSci.pianoPublicConfig.piano_debug_mode || false;
const registrationTermId = newSci.pianoPublicConfig.piano_registration_term_id;
const registrationFreeTrialTermId = newSci.pianoPublicConfig.piano_registration_free_trial_term_id;
const registrationWallSources = [
	'on_registration_wall',
	'on_registration_wall_us',
];
const log = logData => {
	if ( debug ) {
		console.log( 'PIANO ID: ', logData );
	}
};

const pushRegwallRegistrationDataLayer = () => {
	if ( typeof dataLayer === 'undefined' ) {
		return;
	}

	dataLayer.push( {
		event: dataLayerConstants.EVENT_NEW_REGISTRATION,
		[ dataLayerConstants.NEWSLETTER_REGISTRATION_KEY_EVENT_TYPE ]:
      dataLayerConstants.EVENT_TYPE_BROWSING_STOP,
		[ dataLayerConstants.NEWSLETTER_REGISTRATION_KEY_SUB_TYPE ]:
    dataLayerConstants.EVENT_SUBTYPE_REGWALL,
		[ dataLayerConstants.NEWSLETTER_REGISTRATION_KEY_SERVICE_PLATFORM ]:
    dataLayerConstants.SERVICE_PLATFORM_PIANO,
		[ dataLayerConstants.NEWSLETTER_REGISTRATION_KEY_EVENT_DETAILS ]: 'newsletter Opted in',
	} );

	dataLayer.push( {
		event: dataLayerConstants.EVENT_NEWSLETTER_SIGNUP,
		[ dataLayerConstants.NEWSLETTER_SIGNUP_KEY_EVENT_ACTION ]:
    dataLayerConstants.EVENT_ACTION_SUBSCRIBED,
		[ dataLayerConstants.NEWSLETTER_SIGNUP_KEY_EVENT_TYPE ]:
    dataLayerConstants.EVENT_TYPE_BROWSING_STOP,
		[ dataLayerConstants.NEWSLETTER_SIGNUP_KEY_OBJECT_NAME ]:
    dataLayerConstants.DEFAULT_NEWSLETTER_ON_REGISTRATION,
		[ dataLayerConstants.NEWSLETTER_SIGNUP_KEY_EVENT_VALUE ]: 1,
	} );
};

const getRegistrationSuccessSource = data => {
	if ( data?.source === 'OFFER' ) {
		return 'on_piano_checkout';
	}

	if ( tp?.pianoId?.getUser()?.ls === 'GOOGLE' ) {
		return 'on_social_signin_google';
	}

	// flag set in piano composer
	if ( window.regwallShown ) {
		if ( window.regwallCountry === 'US' ) {
			return 'on_registration_wall_us';
		}

		return window.regwallOverride || 'on_registration_wall';
	}

	return 'on_registration';
};

const registrationSuccess = data => {
	log( { 'registrationSuccess callback': data } );
};

const loginRequired = data => {
	log( { 'loginRequired callback': data } );
};

const showLogin = data => {
	log( { 'showLogin callback': data } );
};

const getLoginTargetUrl = () => {
	const locationUrl = new URL( window.location.href );
	const targetPath = locationUrl.searchParams.get( '_target_path' );

	if ( ! targetPath ) {
		return null;
	}

	try {
		const targetUrl = new URL( targetPath, window.location.origin );
		const isInternalUrl = targetUrl.origin === window.location.origin;
		const isLoginUrl = targetUrl.pathname === '/login/' || targetUrl.pathname === '/login';
		const isLogoutUrl = targetUrl.pathname === '/logout/' || targetUrl.pathname === '/logout';

		if ( ! isInternalUrl || isLoginUrl || isLogoutUrl ) {
			return null;
		}

		return targetUrl.href;
	} catch ( e ) {
		return null;
	}
};

const shouldSkipLoginReload = () => {
	const locationUrl = new URL( window.location.href );

	return locationUrl.searchParams.has( 'staffAccess' );
};

const redirectAfterLogin = () => {
	const targetUrl = getLoginTargetUrl();

	if ( targetUrl ) {
		window.location.href = targetUrl;
		return;
	}

	if ( shouldSkipLoginReload() ) {
		return;
	}

	window.location.reload();
};

const isRegistrationPage = () => {
	const path = window.location.pathname.replace( /\/+$/, '' );

	return path === '/registration';
};

const loginSuccess = async data => {
	log( { 'loginSuccess callback': data } );

	const isRegistration = data.registration;
	const isCheckout = data.source === 'OFFER';

	const user = tp.pianoId.getUser();
	const token = tp.pianoId.getToken();
	const registrationSource = isRegistration
		? getRegistrationSuccessSource( data )
		: null;

	const pending = {
		login: false,
		registration: ! isRegistration,
		conversion: ! isRegistration,
		freeTrialConversion: registrationSource !== 'on_registration_wall_us',
		profile: ! isRegistration,
	};

	const complete = key => {
		pending[ key ] = true;
		finishIfReady();
	};

	const finishIfReady = () => {
	  if ( ! Object.values( pending ).every( Boolean ) ) {
		  return;
	  }

	  tp.user.refreshAccessToken( true, function () {
		if ( isCheckout ) {
			return;
		}

		if ( isRegistration && isRegistrationPage() ) {
			window.location.href = '/registration-thank-you/'; // phpcs:ignore WordPressVIPMinimum.JS.Window.location
			return;
		}

		redirectAfterLogin();
	  } );

		
	};

	if (
    registrationWallSources.includes( registrationSource ) ||
    ( window.regwallOverride && registrationSource === window.regwallOverride )
  ) {
		pushRegwallRegistrationDataLayer();
	}

	if ( isRegistration ) {
		tp.pianoId.loadExtendedUser( {
			async extendedUserLoaded ( data ) {
				//Pass UTM values to Piano
				const url = new URL( window.location.href );

				const utmParams = {
					utm_source: url.searchParams.get( 'utm_source' ),
					utm_medium: url.searchParams.get( 'utm_medium' ),
					utm_campaign: url.searchParams.get( 'utm_campaign' ),
					utm_term: url.searchParams.get( 'utm_term' ),
					utm_content: url.searchParams.get( 'utm_content' ),
				};

				const customFields = [
					...Object.entries( utmParams )
						.filter( ( [ _, value ] ) => value )
						.map( ( [ field_name, value ] ) => ( {
							field_name,
							value,
						} ) ),
					{
						field_name: 'source',
						value: registrationSource,
					}, {
						field_name: 'nswebsite_reg_date',
						value: new Date().toISOString().slice( 0, 10 ),
					},
				];


				//If user exists and there are any UTM params added
				if ( user && token && customFields.length > 0 ) {
					const formData = {
						uid: user.uid,
						form_name: 'utmParameters',
						custom_field_values: customFields,
					};

					const pianoFormURL = newSci.pianoPublicConfig.piano_id_base_url + '/identity/userinfo?aid=' + newSci.pianoPublicConfig.piano_application_id + '&access_token=' + token + '&lang=en_UK';

					await fetch(
						pianoFormURL,
						{
							method: 'PUT',
							headers: {
								'Content-Type': 'application/json; charset=UTF-8',
							},
							body: JSON.stringify( formData ),
						} ).then( response => {
						complete( 'profile' );
					} );

					const customFieldValues = Array.isArray( data.custom_field_values ) ? data.custom_field_values : [];

					const registrationData = {
						first_name: data.first_name,
						last_name: data.last_name,
						email: data.email,
						publisher_agreement: customFieldValues.find( field => field.field_name === 'marketing_consent' )?.value ?? false,
						third_party_agreement: customFieldValues.find( field => field.field_name === 'registration_consent_thirdPartyAgreement' )?.value ?? false,
						country: customFieldValues.find( field => field.field_name === 'registration_country' )?.value ?? '',
						source: registrationSource,
						regwall_message: customFieldValues.find( field => field.field_name === 'regwall_message' )?.value ?? '',
						utm_source: utmParams.utm_source ?? null,
						utm_medium: utmParams.utm_medium ?? null,
						utm_campaign: utmParams.utm_campaign ?? null,
						utm_term: utmParams.utm_term ?? null,
						utm_content: utmParams.utm_content ?? null,
					};

					try {
						const response = await fetch(
							'/wp-json/ns-subscribers/v1/register',
							{
								method: 'POST',
								headers: {
									'Content-Type': 'application/json; charset=UTF-8',
								},
								body: JSON.stringify( registrationData ),
							} ).then();

						if ( ! response.ok ) {
							throw new Error( `Response status: ${response.status}` );
						}
					} catch ( error ) {
						console.error( 'Error: calling register endpoint - ', error.message );
					}

					complete( 'registration' );
				}
			}, formName: 'RegistrationFields',
		} );

		tp.api.callApi( '/conversion/list', {}, function ( listData ) {
			if ( listData.code !== 0 ) {
				complete( 'conversion' );
				complete( 'freeTrialConversion' );
				return;
			}

			const conversions = Array.isArray( listData.conversions ) ? listData.conversions : [];
			for ( const conversion of conversions ) {
				if ( conversion?.term?.term_id === registrationTermId ) {
					complete( 'conversion' );
					complete( 'freeTrialConversion' );
					return;
				}
			}

			tp.api.callApi(
				'/conversion/registration/create',
				{ term_id: registrationTermId, pageview_id: tp.main.fetchPageViewId() },
				function () {
					complete( 'conversion' );
				},
			);

			if ( registrationSource === 'on_registration_wall_us' ) {
				tp.api.callApi(
					'/conversion/registration/create',
					{ term_id: registrationFreeTrialTermId, pageview_id: tp.main.fetchPageViewId() },
					function () {
						complete( 'freeTrialConversion' );
					},
				);
			}
		} );
	}

	const tokenData = {
		token: data.user_token,
	};

	const urlParams = new URLSearchParams( tokenData );
	const tokenDataString = urlParams.toString();

	fetch( '/wp-json/ns-subscribers/v1/login', {
		method: 'POST',
		headers: {
			'Content-type': 'application/x-www-form-urlencoded',
			'X-Requested-with': 'XMLHttpRequest',
		},
		body: tokenDataString,
	} ).then( response => {
		if ( response.ok ) {
		  complete( 'login' );
		}
	} );
};

const logoutHandler = async data => {
	log( { 'logout callback': data } );
	if ( window.forceLogout ) {
		document.location.reload();
		return;
	}
	// log user out via Aegis for server-side
	document.location.href = '/logout';
};

const initHandler = data => {
	log( { 'init callback': data } );
};

const signInButtons = document.querySelectorAll( '.js-sign-in-button' );
signInButtons.forEach( button => {
	button.addEventListener( 'click', e => {
		loginShowHandler();
	} );
} );

const logoutButtons = document.querySelectorAll( '.js-logout' );
logoutButtons.forEach( button => {
	button.addEventListener( 'click', e => {
		tp.pianoId.logout();
	} );
} );
const loginShowHandler = () => {
	tp.push( [ 'init', () => {
		tp.pianoId.show();
	} ] );
};

// check if we need to init passwordless login
const locationUrl = new URL( window.location.href );

if ( locationUrl.searchParams.has( 'passwordless_token' ) ) {
	tp.push( [ 'init', function () {
		tp.pianoId.init( { returnBack: false } );
	} ] );

	// https://docs.piano.io/faq-article/how-to-hide-the-welcome-back-screen-after-a-user-uses-a-magic-link-for-login/
	window.addEventListener( 'message', event => {
		let ev_json = event.data;
		if ( typeof event.data !== 'object' ) {
			ev_json = JSON.parse( event.data );
		}
		if ( ev_json.event == 'loaded' ) {
			if ( ev_json.sender.startsWith( 'piano-id-form' ) ) {
				document.getElementsByClassName( 'tp-close' )[ 0 ].click();
			}
		}
	} );
}

const checkoutClose = event => {
	if ( event && event.state === 'close' ) {
		// phpcs:ignore WordPressVIPMinimum.JS.Window.location -- value is only used for internal routing logic, never rendered to DOM
        const urlParams = new URLSearchParams(window.location.search);
        const isMyAccountPage = urlParams.has('myaccount');
        
        if (!isMyAccountPage) {
            location.reload();
        }
	}
};

window.tp = window.tp || [];

window.tp.push( [ 'addHandler', 'showLogin', showLogin ] );
window.tp.push( [ 'addHandler', 'loginRequired', loginRequired ] );
window.tp.push( [ 'addHandler', 'registrationSuccess', registrationSuccess ] );
window.tp.push( [ 'addHandler', 'loginSuccess', loginSuccess ] );
window.tp.push( [ 'addHandler', 'logout', logoutHandler ] );
window.tp.push( [ 'addHandler', 'checkoutClose', checkoutClose ] );
